import Vue from 'vue'
import { Form, Button, Input, Modal } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'

import './css/index.less'

Vue.use(Storage)
Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.prototype.$confirm = Modal.confirm
Vue.use(SliderCaptcha)
